import { render } from "./admin-pdal-pipelines.vue?vue&type=template&id=2387f38e&ts=true&lang=pug"
import script from "./admin-pdal-pipelines.vue?vue&type=script&lang=ts"
export * from "./admin-pdal-pipelines.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__